import YouTubeVideo from './YouTubeVideo'

export default YouTubeVideo
